import { render } from "./similar-coaches.vue?vue&type=template&id=f7ed74c2"
import script from "./similar-coaches.vue?vue&type=script&lang=js"
export * from "./similar-coaches.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__